import Vue from 'vue'
export const DEVELOPER_TEMPLATE_RETURN = 'DEVELOPER_TEMPLATE_RETURN'
export const DEVELOPER_DATA_ENTRY_RETURN = 'DEVELOPER_DATA_ENTRY_RETURN'
export const DEVELOPER_PIPELINE_RETURN = 'DEVELOPER_PIPELINE_RETURN'
export const DEVELOPER_TRAIN = 'DEVELOPER_TRAIN'
export const DEVELOPER_AUTOMATION_PLATFORM = 'DEVELOPER_AUTOMATION_PLATFORM'
export const DEVELOPER_AUTOMATION_TEAM_PROCESSED = 'DEVELOPER_AUTOMATION_TEAM_PROCESSED'
export const DEVELOPER_AUTOMATION_TEAM_SAVED = 'DEVELOPER_AUTOMATION_TEAM_SAVED'
export const DEVELOPER_AUTOMATION_TEAM_COMPLETED = 'DEVELOPER_AUTOMATION_TEAM_COMPLETED'
export const DEVELOPER_AUTOMATION_TEAM_REJECTED = 'DEVELOPER_AUTOMATION_TEAM_REJECTED'
export const DEVELOPER_COMPLETE_NO_ACTION = 'DEVELOPER_COMPLETE_NO_ACTION'
export const DEVELOPER_AUTOMATION_TEAM_APPROVAL = 'DEVELOPER_AUTOMATION_TEAM_APPROVAL'

export const developerTypes = Object.freeze({
    [DEVELOPER_TRAIN]: {
        key: DEVELOPER_TRAIN,
        label: `Train ${Vue.prototype.appDisplayName} on Invoice`
    },
    [DEVELOPER_AUTOMATION_TEAM_REJECTED]: {
        key: DEVELOPER_AUTOMATION_TEAM_REJECTED,
        label: 'Run Team Automation: Rejected'
    },
    [DEVELOPER_AUTOMATION_TEAM_APPROVAL]: {
        key: DEVELOPER_AUTOMATION_TEAM_APPROVAL,
        label: 'Run Team Automation: Approval'
    },
    [DEVELOPER_AUTOMATION_TEAM_COMPLETED]: {
        key: DEVELOPER_AUTOMATION_TEAM_COMPLETED,
        label: 'Run Team Automation: Completed'
    },
    [DEVELOPER_AUTOMATION_TEAM_SAVED]: {
        key: DEVELOPER_AUTOMATION_TEAM_SAVED,
        label: 'Run Team Automation: Saved'
    },
    [DEVELOPER_AUTOMATION_TEAM_PROCESSED]: {
        key: DEVELOPER_AUTOMATION_TEAM_PROCESSED,
        label: 'Run Team Automation: Processed'
    },
    [DEVELOPER_AUTOMATION_PLATFORM]: {
        key: DEVELOPER_AUTOMATION_PLATFORM,
        label: 'Run Platform Automation'
    },
    [DEVELOPER_COMPLETE_NO_ACTION]: {
        key: DEVELOPER_COMPLETE_NO_ACTION,
        label: 'Mark as complete without processing'
    },
    [DEVELOPER_PIPELINE_RETURN]: {
        key: DEVELOPER_PIPELINE_RETURN,
        label: 'Reprocess Invoice'
    },
    [DEVELOPER_TEMPLATE_RETURN]: {
        key: DEVELOPER_TEMPLATE_RETURN,
        label: 'Return Invoice to Templating'
    },
    [DEVELOPER_DATA_ENTRY_RETURN]: {
        key: DEVELOPER_DATA_ENTRY_RETURN,
        label: 'Send Invoice to data entry'
    }
})

export const developerTypesList = Object.freeze(Object.values(developerTypes))
